import { gql } from "@apollo/client";

const PRO_PLAYER_FIELDS = gql`
  fragment ProPlayerFields on ProPlayerSearchResult {
    id
    name
    fullName
    avatar
    countryIso
    gameIdentifier
    featured
    latestMatchDate
    team {
      id
      name
      logo
    }
  }
`;

export const FEATURED_PRO_PLAYERS = gql`
  ${PRO_PLAYER_FIELDS}
  query FeaturedProPlayers {
    proPlayers(featured: true, first: 24) {
      ...ProPlayerFields
    }
  }
`;

export const PRO_TEAMS = gql`
  ${PRO_PLAYER_FIELDS}
  query ProTeams {
    proTeams {
      id
      name
      logo
      players {
        ...ProPlayerFields
      }
    }
  }
`;

// Same clip fields as the /today playlist, so the shared list, player and
// details components render these clips unchanged.
export const PRO_PLAYER_CLIPS = gql`
  query ProPlayerClips(
    $after: String
    $createdAfter: ISO8601DateTime
    $playerGameIdentifiers: [String!]!
    $sort: ClipSort
  ) {
    clipsNew(
      first: 30
      after: $after
      sort: $sort
      filters: {
        game: CS2
        playerGameIdentifiers: $playerGameIdentifiers
        createdAfter: $createdAfter
        filters: [{ key: "isProPlayer", values: ["true"] }]
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        createdAt
        developer {
          profile {
            internalId
          }
        }
        score
        shareId
        playerGameIdentifier
        thumbnailStandardUrl: thumbnailUrl(style: STANDARD)
        title
        user {
          _id
          avatarUrl
          username
        }
        username
        views
        tags {
          key
          value
        }
      }
    }
  }
`;

export const SEARCH_PRO_PLAYERS = gql`
  ${PRO_PLAYER_FIELDS}
  query SearchProPlayers($query: String!) {
    proPlayerSearch(query: $query, count: 20) {
      game
      ...ProPlayerFields
    }
  }
`;
